import React, { ReactNode } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { Box, BoxProps, HStack } from "@chakra-ui/layout";
import { DragHandleIcon } from "@chakra-ui/icons";

interface SortableItemProps {
  children?: ReactNode;
  id: string;
}

export function SortableItem(props: SortableItemProps & BoxProps) {
  const { listeners, setNodeRef, transform, transition } = useSortable({
    id: props.id,
  });

  return (
    <HStack ref={setNodeRef} {...props}>
      <Box
        {...listeners}
        px={1}
        borderRadius={2}
        background="cherryGrey.160"
        _hover={{ cursor: "pointer" }}
      >
        <DragHandleIcon boxSize={3} />
      </Box>
      {props.children}
    </HStack>
  );
}
